import { ActionIcon, Button, Flex, Tooltip } from "@mantine/core";
import PageHeader from "../../../../shared/components/blocks/PageHeader";
import { useCalendarContext } from "../../../../contexts/CalendarContext";
import CountBadge from "../../../../shared/components/ui/CountBadge";
import { COLORS } from "../../../../constants/colorConstants";
import { IconRefresh } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export default function CalendarListHeader() {
  const { tableFetch } = useCalendarContext();

  return (
    <PageHeader
      title="Calendars"
      actions={
        <Flex justify="flex-end" align="center" gap="xl">
          <CountBadge
            filteredCount={tableFetch?.data?.filteredCount || 0}
            fetchCount={tableFetch?.data?.fetchCount || 0}
            totalCount={tableFetch?.data?.totalCount || 0}
          />
          <RefreshButton tableFetch={tableFetch} />
          <LoadMoreButton tableFetch={tableFetch} />
          <CreateButton />
        </Flex>
      }
    />
  );
}

function RefreshButton({ tableFetch }) {
  return (
    <Tooltip label="Refresh calendar list" position="bottom" withArrow>
      <ActionIcon
        variant="filled"
        color={COLORS.DARK_BROWN}
        onClick={tableFetch.refetch}
        loading={tableFetch.isRefetching}
      >
        <IconRefresh size={18} color={COLORS.WHEAT} />
      </ActionIcon>
    </Tooltip>
  );
}

function LoadMoreButton({ tableFetch }) {
  if (tableFetch?.data?.fetchCount < tableFetch?.data?.totalCount) {
    return (
      <Tooltip label="Load the next batch of calendars" position="bottom" withArrow>
        <Button
          size="sm"
          radius="lg"
          bg={COLORS.DARK_BROWN}
          c={COLORS.WHEAT}
          fw={700}
          onClick={tableFetch.fetchNextPage}
          loading={tableFetch.isFetchingNextPage}
        >
          Load More
        </Button>
      </Tooltip>
    );
  }
}

function CreateButton() {
  const navigate = useNavigate();

  return (
    <Button
      size="sm"
      radius="lg"
      bg={COLORS.DARK_WINE}
      c={COLORS.WHEAT}
      fw={600}
      fz={16}
      onClick={() => navigate("/calendars/create")}
    >
      Create Calendar
    </Button>
  );
}
